import { AnalyticsModuleType } from '@app/modules/analytics';
import { REPORT_GROUP_TYPE } from '@main/enums';
import { Currency, WidgetMetric } from '@shared/models';

export class AnalyticsGeneralPropertiesHelpers {
    static readonly metricSignMap = {
        [WidgetMetric.Both]: '# %',
        [WidgetMetric.Number]: '#',
        [WidgetMetric.Percentage]: '%',
    };

    static getModuleType(type: REPORT_GROUP_TYPE): AnalyticsModuleType {
        return {
            [REPORT_GROUP_TYPE.ADCLARITY]: 'Ad Intelligence',
            [REPORT_GROUP_TYPE.DASHBOARDS]: 'Dashboard',
            [REPORT_GROUP_TYPE.AUDIENCE_DEMOGRAPHIC]: 'Audience',
            [REPORT_GROUP_TYPE.AUDIENCE_INTEREST]: 'Audience',
        }[type] as AnalyticsModuleType;
    }

    static getMetricsPayload(oldVal: WidgetMetric, newVal: WidgetMetric): { 'Default metrics': string } {
        return {
            'Default metrics': `${AnalyticsGeneralPropertiesHelpers.metricSignMap[newVal]} ${newVal}`,
        };
    }

    static getCurrencyPayload(newVal: Currency): { 'Default currency': string } {
        return {
            'Default currency': `${newVal.symbol} - ${newVal.name}`,
        };
    }
}
